import { PHONE_RING_SOUND } from "../constants";

class AudioService {
  constructor() {
    this.audio = null;
    this.isPlaying = false;
  }

  init() {
    if (!this.audio) {
      this.audio = new Audio(PHONE_RING_SOUND);
      this.audio.loop = true;
      this.audio.preload = "auto";
      this.audio.controls = false;
      this.audio.setAttribute('controlsList', 'nodownload nofullscreen noremoteplayback');
      
      this.audio.addEventListener('play', () => {
        this.isPlaying = true;
        console.log("✅ Visit Now ring started");
      });
      
      this.audio.addEventListener('pause', () => {
        this.isPlaying = false;
        console.log("⏸️ Visit Now ring paused");
      });
    }
  }

  async play() {
    console.log("🔔 Attempting to play Visit Now ring...");
    this.init();
    
    if (this.isPlaying && !this.audio.paused) {
      console.log("🔄 Visit Now ring already playing");
      return;
    }
    
    try {
      this.audio.currentTime = 0;
      await this.audio.play();
      console.log("✅ Visit Now ring play successful");
    } catch (error) {
      console.error("❌ Visit Now ring play failed:", error);
      setTimeout(() => {
        this.audio.play().catch(e => console.error("❌ Fallback play failed:", e));
      }, 100);
    }
  }

  stop() {
    console.log("🛑 Stopping Visit Now ring...");
    if (this.audio && !this.audio.paused) {
      this.audio.pause();
      this.audio.currentTime = 0;
      console.log("✅ Visit Now ring stopped");
    }
    this.isPlaying = false;
  }

  cleanup() {
    console.log("🧹 Cleaning up Visit Now audio service...");
    this.stop();
    this.audio = null;
  }
}

export default new AudioService();